export enum PaybackActionTypeEnum {
  BET = 'bet',
}
